var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1052 0.53125C35.992 0.531219 32.0929 4.94743 29.0001 8.00999C25.9073 4.94743 22.0083 0.531219 14.895 0.53125C7.78179 0.531281 0.424123 7.2429 0.790485 16.831C0.790485 30.4461 19.2353 42.4312 29.0001 49.2388C38.7649 42.4312 57.2098 30.4461 57.2098 16.831C57.5761 7.2429 50.2185 0.531281 43.1052 0.53125Z",
    fill: "url(#paint0_radial_12419_19822)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12419_19822",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8487 0.531253) rotate(127.736) scale(61.5899 73.8676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330493,
    stopColor: "#CAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333117,
    stopColor: "#BAB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630108,
    stopColor: "#BBB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#9E9CFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.49b97056e1122f8560c0abf828fd5880.svg";
export { ForwardRef as ReactComponent };